import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.7175 6.01667L11.1792 16.4283C11.0992 16.5544 10.9886 16.6582 10.8576 16.7299C10.7266 16.8017 10.5796 16.839 10.4303 16.8385C10.281 16.838 10.1342 16.7997 10.0037 16.7271C9.87326 16.6545 9.76332 16.55 9.68418 16.4233L3.27335 6.01167C3.09341 5.72022 2.99872 5.38419 3.00001 5.04167C3.00769 4.53568 3.21603 4.05345 3.57922 3.70105C3.9424 3.34865 4.43068 3.15493 4.93668 3.16251H16.0717C17.1358 3.16167 18 4.00001 18 5.03667C18 5.38084 17.9033 5.72084 17.7175 6.01667ZM4.84835 5.66667L9.61751 13.0217V4.92667H5.34668C4.85335 4.92667 4.63251 5.25334 4.84835 5.66834M11.3817 13.0233L16.1525 5.66667C16.3733 5.25251 16.1475 4.92501 15.6533 4.92501H11.3833L11.3817 13.0233Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }